import { Router } from '@angular/router';
/* eslint-disable max-len */
import { LocalStorageService } from './../../local-storage.service';
import { QUESTION_DATA } from './../questionData';
import { Component, OnInit } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { AlertController } from '@ionic/angular';




@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {


  thumbUpImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABCRJREFUeNrsndtR20AUQJeEf0wFiAqsVGClApTPfMXpgFSAO3CowKECoAJMBTYVWKnATgWKFNYT40nAllfau3vPmbljzIws0D371FprDADo5Uj5/9+rYljFwP6c2t/Pq1hVcV/FtIoCVeIiqWJSRbljLKoY2+MgcOoSv9wj+dsxtrUFBMj4gMRvxgwJwuPSUfKRIEAyx8lfxwOXNgwWLQlQ2j4FCO/0lS3GjEssm1nLApQhDw/fKZjoSTs4T44AMkk7Os8AAeT2/mMSDQGEkoTaD4hdgJMImxsEEJoUBFBOHwFkts0xnssZsS8IKbmeemuAnpJzIoCgTlmKALprADqBymuADAHkcEb51i1AQnp1C+CjOj5BAN2ln1GA4g4gTQACIIAUBqRWtwAZqdUrAMlXLsCFx3M/IoB/csq1XgEywwygagGuPJ9/hVJ+x/6l58ioAfwxpgzoJRNQ+utgEYonFkIEoBPogZGQnv+Ucqiz47eOCTVAt/SEXfSflMdumQgq/UEOAUNmKCz5wY4AjgNt96W1t4WtAdYLUfpbQqRb7wvz8vnD9bOJf9nXwr7Cf5K/FFj623oG4ciwuulFp2+mJPn/elj1SPNEk+bkb0Zd++Ukn5hoSb6mNh8JtshJvl4JRiR357iMKfGJHf6Q2P0ijaXUU+Ur3LdgaOTczw85MhKvO26bJKHrx5rVPfsL+8ryKfecGoErkzM7XKF9bz+G+ybnuOXEXxnuk3eJmMfVjimNYYwGXNcAPdsZodQHgmsBHgz3r4PC5aLQCcnXK0Bu2EBRtQB8L08GhQ8B6tKfcO1F8OhDgAuuuxjufAjAkE9O8veeBnZxL6Dk2ovgo2nwBVV2DYun9E+bHIgAcXDjexgIfvnS9ED6APHQaC0ANUA8NPrGEALEQx8BdNPoRhx9gHhY2X4AAihm73zSBCgHARAAEAAQABAAwh8GIoBi5giAAAigmKcmBzETGA/cDlZMowWhCBAP1wwDdVMggG5yBNDNAAF000MAQABAAEYBCKCSJwTQzbTpgdwLiKP6P6cG0MvNIQdTA4TPOZ1Avfw4JPnUAGFT3/79cKgALmqAglx44drFtX/v4A9JDY+I7Zp6/d9nFx/koga4Jx+d89XVB7kQ4I5moHMSSQI4NRJ2bnZFCTCt4jt5CQ+X8wDf7LgUlAqwbgqQQLEAawk+GYH710XESrIA65HBuW0W5uSrlXkAJ3S1c2hi/k4YnW28Z/fQZqX/NJZ/phagXtNebzkzM+z7t0tMYp/guDRsKv1aJFqqusw870NI0pWUfkR4PZZG+eZcQ6N7B/LcwJ9Oo8aNqUekXm+zQPLfaBZiHTEsDdvx7kweWY3wYNiN9aB5hFAnlW5NxxtxHkUsQ89ezHrKub/xXhL1nH5hnpfVTY2HlVW/BRgAv34IbhM8mmEAAAAASUVORK5CYII=';
  thumbDownImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAJJREFUeNrsneFxGjEQRmVP/odUkKMCnyuAVBCnguAOSAUhFRBXgFNBnAqMKwAqgFRwpAJymhGZG0Icc+iklfa9mR3s8TCDtZ9WuytxMgYA9HKR+f/Xq62sbVjba/fz4d9iMHevm9pW7vclcvTDTW3T2ta17RIy+3knTpjQYqZPEnT6Mavc/wIvoKhtloHTj9ki4hKVzIzfZW6VW9LgYI2vFDi/aYjAhftHZY5vRoKScK/b1toqhL3jK5z/x1RUB6XL7HH88aWgyHGmp9q8ST4KhGwFFwd25V6pdU/Dto/7qYVzZrZfEz9pNJdsIWzky1GXHTh/5NqYQ6J1pxPMC686cP4M/6TDJc5HAD6TPVAqgClDGbwUFCOAkoQvOEtJAviIP4LzWdKHWVCXp3tGwEcreMeEjJYHXNe2lVIGQliK2sZEAN3Y2d8/JwoQAdKmd24uQATIoyS8RgC66ZuWzSGWgDwYkgPo5goB6KZEAIAAAAEAAlDJEwLQzQMC0A17AcppfUCEVnA+EeANEUAvrXcFEUA+lAhANwMEoJuCJBAuiACAAAABAAIABAAIABCAFuYIQDcbBKCbVZs30QnMh1bfDiIC5MGSJUA3d1QBuinavpEcgBzgbLaMvQhaHQz1IYA5Yy8CeyawF0MAPxh7EVjnD2MI4IFlQAyDGALYnlOGgFfKGAKwTAzXnyeJz0uj7Bqk7nLD1H3qsxFkl4J35ANRidIHaGKXgT6loV4BNCPBJ6JBcLYSBLDnq4sGX4zHGy7gWU5+UkjIm0NtiWK7Ve8Nt4V2RT+Vyba/ZIqLH/zZIkXF2pJxivNk3SYag6K27zixta1zWcNsjlDh0Dj3B0laFrh4+uWW7YWdE5z7osQv69b7CCfrdX6zZCQvUOp8RPC3TY3SHVftIrCJ8VB7q/NGmdNtb2Rszjj3L2kvwGdiKK302R+LGzSi1Slhet7YzLG9/KXhhNWzSNxH+B9DZ2yEeULareVJrs8pfzfwg5F14KREAGGxa+WtoM/zlqAcBym7iI+4Ig49If2BClfEY5xIJQAdsqYS0JUEHnLLHNAtgLmJ3z0rEEBc7hCAbgHcG76NpFoAlgfcqlsAMR9Zc4UAZCSDseghgPhsDXvpqgUQOwogAAGscK1uAbAEIACEp1kAsZzxCwHIYUOA1y0AEkEiADkAAgjLFgHoFkByeceFyZsd46k3AoQOyUlWHbkLYIkAdAsgJE8IQHciSAQQyE96ACwBoZJNBKA4CUx2+xkBKE4AtRDiO4MlEUAu3wJk/5xAEkzXzw+YMMTy6er5AQuGNh18P1quMjzyLbmlYIHz4dxIsMD56XPTojy0jh8xdPkJYfYPMazd36zTi1wH4LcAAwDIQ2Clqn0C+wAAAABJRU5ErkJggg==';

  questions = QUESTION_DATA;
  showAnswers = [];
  constructor(
    private localStorageService: LocalStorageService,
    private alertCtrl: AlertController,
    private router: Router) { }

  ngOnInit() {

  }

  ionViewWillEnter() {
    //this.slider.lockSwipes(true);
    //load data and scroll to the current question
    let savedAnswers = this.localStorageService.get('questionnaire');
    if (savedAnswers === null) {
      savedAnswers = [];
    }
    savedAnswers.forEach((element, index) => {
      this.questions[index].answer = element;
      this.showAnswers[index] = false;
    });
  }

  toggleQuestion(index: number, $event){
    this.showAnswers[index] = !this.showAnswers[index];
  }

  nextButtonHandler(){
    this.router.navigate(['/questionnaire/link']);
  }

  stripHtml(html: string, removeEmojis){
    //replace all html tags and square brackets
    let retVal = html.replace(/<[^>]*>|[\[\]']?/gm, '');
    if(removeEmojis){
      retVal = retVal.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
    }
    return retVal;
  }


  async startAgain(){

      const alert = this.alertCtrl.create({
        header:'Neu starten',
        message: 'Möchtest Du wirklich neu starten? Deine bisher gespeicherten Eingaben werden dann überschrieben.',
        cssClass: 'alertBox',
        buttons: [
          {
            text: 'Abbrechen',
            role: 'cancel',
          },
          {
            text: 'Neu starten',
            handler: () => {
              //remove answers
              this.localStorageService.remove('isFinishedCheck');
              this.localStorageService.remove('questionnaire');
              this.router.navigate(['/questionnaire/question']);
            }
          }
        ]
      }).then(res => {
        res.present();
      });
  }

  downloadPdf(){
    const pdfMakeInstance = pdfMake;
    (pdfMakeInstance as any).vfs = pdfFonts && (pdfFonts as any).pdfMake ? (pdfFonts as any).pdfMake.vfs : (pdfFonts as any).vfs;

    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    const test = {
      header: {
        margin:[40,10,40,10],
        columns: [
            {
                table: {
                    widths: [ '50%','50%'],
                    body: [
                        [
                            { text: ' '},
                            { text: '#ORIENTANDO – Mit Perspektive in die Zukunft',alignment:'right'}
                        ]
                    ]
                },
                layout: 'noBorders'
            }
        ]
    },
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      footer(currentPage, pageCount) {
        return [
          {
            margin:[40,10,40,10],
            columns:[
              { text: today.toLocaleDateString(), alignment:'left' },
              { text: 'Seite '+currentPage.toString() + ' von ' + pageCount, alignment:'right' }
            ]
          }
        ];
      },
      content: []
    };
    test.content.push(
      {
        fontSize: 30,
        text: '#Erwartungscheck\n',
        color: '#4e6066'
    }
    );
    test.content.push(
      {
        fontSize: 20,
        text: 'Dein Ergebnis\n\n\n',
        color: '#4e6066'
    }
    );

    this.questions.forEach((element,index) =>{
      const img = element.answer?this.thumbUpImage:this.thumbDownImage;
      const txt = element.answer?element.feedbackTextYes:element.feedbackTextNo;
      test.content.push( {
        columns: [
          {
            width: '30%',
            stack:[
              {
                text: this.stripHtml(element.title, true)+'\n\n'
              },
              {
                image: img,
                alignment: 'center',
                width: 30
              },
            ]
          },
          {
            width: '70%',
            text: this.stripHtml(txt, true),
            color: '#4e6066'
          },
        ],
        // optional space between columns
        columnGap: 10
      },);
      test.content.push('\n. . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . \n\n');
    });
    pdfMake.createPdf(test).download('Ergebnis_Orientando.pdf');
  }

}
